
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.86 14.497"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_32384","data-name":"Path 32384","d":"M14.929 3.7l-.492 8.375a1.772 1.772 0 01-1.77 1.668H4.194a1.772 1.772 0 01-1.77-1.668L1.932 3.7m6.5 2.363v5.317m0 0L6.067 9.021m2.363 2.363l2.363-2.363M1.636 3.7h13.588a.886.886 0 00.886-.886V1.636a.886.886 0 00-.886-.886H1.636a.886.886 0 00-.886.886v1.182a.886.886 0 00.886.882z","fill":"none","stroke":"#6d7392","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    